module.exports = __webpack_public_path__ + "img/9788983091079.76c43ab3.jpg";